import axios from "axios";
import { useQuery } from "react-query";

const api_base_url = process.env.REACT_APP_API_BASEURL + "/Agreements";

const getAgreementCommssion = async (id) => {
  const { data } = await axios.get(
    `${api_base_url}/AgreementsCommission/${id}`
  );
  return data;
};
export const useGetAgreementComm = (id, enabled = false) => {
  return useQuery(["getAgreementComm", id], () => getAgreementCommssion(id), {
    enabled: enabled,
  });
};
